import {
  Organizacia as OrganizaciaGenerated,
  OrganizaciaListExternalApi,
  OrganizacnaSkupinaEnum,
} from 'ciselniky-frontend-ts-axios';
import { ClientResponse } from '../../../model/types/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ciselnikyPrefixPath } from '../../configuration/apiConfigurationConstants';
import Organizacia from '../../../model/ciselniky/Organizacia';

const client = new OrganizaciaListExternalApi(apiConfiguration(ciselnikyPrefixPath));

function map(organizacie: OrganizaciaGenerated[]): Organizacia[] {
  return organizacie.map(organizacia => ({
    uuid: organizacia.uuid,
    nazov: organizacia.uplnyNazov,
    skratenyNazov: organizacia.skratenyNazov,
    email: organizacia.kontakt.email,
    ldapUuid: organizacia.ldapUuid,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchOrganizacie = async (
  typ?: OrganizacnaSkupinaEnum,
  ids?: string[],
  ldap?: boolean,
  nazov?: string,
  legislativna?: boolean,
  limit?: number,
  // eslint-disable-next-line default-param-last
  shouldFetch = true,
  headers?: object,
):
  Promise<ClientResponse<Organizacia[]>> => {
  if (!shouldFetch) {
    return {
      data: [],
      responseCode: 200,
    };
  }

  const {
    data,
    status,
  } = await client.getOrganizaciaList(typ, ids, ldap, nazov, legislativna, limit, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
